import { render } from "./ArmourAbilityCompendiumModal.vue?vue&type=template&id=e1901c3a"
import script from "./ArmourAbilityCompendiumModal.vue?vue&type=script&lang=js"
export * from "./ArmourAbilityCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__